import axios from "axios";
import { decryptRequest } from "../utils/crypt";
const getAlertsList = async (params) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.get(
    `https://godrej.app-assertai.com:5000/Table/alertsTable`,
    {
      params,
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return {
    pagination: JSON.parse(dataafterdecryption).pagination,
    data: JSON.parse(dataafterdecryption),
  };
};

const exportAlertsList = async (params) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.get(
    `https://godrej.app-assertai.com:5000/Table/exportalertsTable`,
    {
      params,
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return JSON.parse(dataafterdecryption).data;
};

const getManualAlertsList = async (params) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.get(
    `https://godrej.app-assertai.com:5000/Table/manualalertsTable`,
    {
      params,
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { data: JSON.parse(dataafterdecryption) };
};

const createAlert = async (params) => {
  let token = localStorage.getItem("token");
  let { status, data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Table/createManualAlerts`,
    {
      params,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  return { status: status, message: data.message };
};
const editAlert = async (params) => {
  let token = localStorage.getItem("token");
  let { status, data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Table/editAlerts`,
    {
      params,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  return { status: status, message: data };
};
const editAlertManual = async (params) => {
  let token = localStorage.getItem("token");
  let { status, data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Table/editAlertsManual`,
    {
      params,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  return { status: status, message: data };
};

const postComment = async ({ id, comments }) => {
  const token = localStorage.getItem("token");

  // Construct the request payload
  const payload = {
    id: id,
    comments: comments.map((comment) => ({
      date: comment.date,
      time: comment.time,
      comment: comment.comment,
      name: comment.name,
      attachments: comment.attachments || [], // Include attachments array
    })),
  };

  try {
    const { data } = await axios.post(
      `https://godrej.app-assertai.com:5000/Table/postcomments`,
      payload,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

    const dataAfterDecryption = await decryptRequest(data.data);
    return { data: JSON.parse(dataAfterDecryption) };
  } catch (error) {
    console.error("Error posting comments:", error);
    throw error;
  }
};

const postCommentForManual = async ({ id, comments, commentText, name }) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Table/postcommentsformanualalerts`,
    {
      id: id,
      comments: [
        {
          date: new Date().toDateString(),
          time: new Date().toLocaleTimeString().split(" ")[0],
          comment: commentText,
          name: name,
        },
        ...(comments || []),
      ],
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { data: JSON.parse(dataafterdecryption) };
};

const postCommentForBulkStatusClose = async (ids, commentText, name) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Table/bulkcloseComment`,
    {
      ids: ids,
      comment: commentText,
      name: name,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { data: JSON.parse(dataafterdecryption), message: data.message };
};

const commentList = async (id) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Table/commentsList`,
    {
      id,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { data: JSON.parse(dataafterdecryption) };
};
const manualcommentList = async (id) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Table/commentsListformanualalerts`,
    {
      id,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { data: JSON.parse(dataafterdecryption) };
};
const updateAlertStatusToInProgress = async ({ _id }) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Table/updateAlertToInProgress`,
    {
      id: _id,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  return data.status;
};
const updateAlertStatusToInProgressForManualAlerts = async ({ _id }) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Table/updateAlertToInProgressformanualalerts`,
    {
      id: _id,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  return data.status;
};
const closeStatus = async ({ _id, name }) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Table/updateAlertToClose`,
    {
      _id,
      name,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { status: data.status, data: JSON.parse(dataafterdecryption) };
};
const manualcloseStatus = async ({ _id, name }) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Table/updateAlertToCloseForManualAlerts`,
    {
      _id,
      name,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { status: data.status, data: JSON.parse(dataafterdecryption) };
};
const bulkCloseStatus = async (idList) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Table/bulkCloseAlerts`,
    {
      ids: idList,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { data: JSON.parse(dataafterdecryption), status: data.status };
};

export {
  exportAlertsList,
  getAlertsList,
  getManualAlertsList,
  postComment,
  commentList,
  closeStatus,
  bulkCloseStatus,
  postCommentForBulkStatusClose,
  updateAlertStatusToInProgress,
  createAlert,
  editAlert,
  editAlertManual,
  postCommentForManual,
  manualcloseStatus,
  updateAlertStatusToInProgressForManualAlerts,
  manualcommentList,
};
